import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { JOB_DETAIL_TOP4_AS_HIGHLY_RECOMMENDED_AB_TEST_GROUP } from '@doda/common/src/constants/markTop4AsHighlyRecommend';
import { JobDetailTop4AsHighlyRecommendAbTestGroup } from '@doda/common/src/types/markTop4AsHighlyRecommend';
import { RootState } from 'redux/store';

/**
 * JobDetailHighlyRecommendABTestState
 * Manages AB test pattern for job detail recommend section highlighting
 */
export interface JobDetailHighlyRecommendABTestState {
  jobDetailHighlyRecommendTestPattern: JobDetailTop4AsHighlyRecommendAbTestGroup;
}

/**
 * Initial state for JobDetailHighlyRecommendABTest
 */
export const jobDetailHighlyRecommendABTestInitialState: JobDetailHighlyRecommendABTestState =
  {
    jobDetailHighlyRecommendTestPattern:
      JOB_DETAIL_TOP4_AS_HIGHLY_RECOMMENDED_AB_TEST_GROUP.FAILED,
  };

/**
 * JobDetailHighlyRecommendABTest Slice
 */
export const jobDetailHighlyRecommendABTestSlice = createSlice({
  name: 'jobDetailHighlyRecommendABTest',
  initialState: jobDetailHighlyRecommendABTestInitialState,
  reducers: {
    /**
     * Set the AB test pattern for job detail recommend section
     * @param state
     * @param action
     */
    setJobDetailHighlyRecommendTestPattern: (
      state,
      action: PayloadAction<JobDetailTop4AsHighlyRecommendAbTestGroup>
    ) => {
      state.jobDetailHighlyRecommendTestPattern = action.payload;
    },
  },
});

/**
 * Actions
 */
export const { setJobDetailHighlyRecommendTestPattern } =
  jobDetailHighlyRecommendABTestSlice.actions;

/**
 * Reducer
 */
export const jobDetailHighlyRecommendABTestReducer =
  jobDetailHighlyRecommendABTestSlice.reducer;

/**
 * Selectors
 */

/**
 * jobDetailHighlyRecommendSelector
 * Returns the AB test pattern for job detail recommend section
 * @param state
 * @returns JobDetailTop4AsHighlyRecommendAbTestGroup
 */
export const jobDetailHighlyRecommendTestPatternSelector = (
  state: RootState
): JobDetailTop4AsHighlyRecommendAbTestGroup =>
  state.jobDetailHighlyRecommendABTest.jobDetailHighlyRecommendTestPattern;
